// GENERATED from messaging-platform/packages/chat-core/src/patient-chat.ts. Do not edit here: edit there, then run scripts/sync-chat-core.cjs.
/**
 * The Chat button on a money card (Connect dashboard, clinical Connect page): the people a first chat about a patient
 * can be with, and the name of a group about them. Framework-free, like the rest of chat/core.
 */

import type { BillingPerson, PatientMention } from './hub-types';

/** A person in the picker: `treating` marks the claim's doctor, who is ticked to start with. */
export interface PickerPerson extends BillingPerson {
  treating: boolean;
  picked: boolean;
}

/** The other side's people, the treating doctor (by clinical user id) first and ticked, everyone else by name. */
export function pickerPeople(people: readonly BillingPerson[], treatingClinicalUserId: string | null | undefined): PickerPerson[] {
  const isTreating = (p: BillingPerson) => !!treatingClinicalUserId && p.clinicalUserId === treatingClinicalUserId;
  return people
    .map((p) => ({ ...p, treating: isTreating(p), picked: isTreating(p) }))
    .sort((a, b) => Number(b.treating) - Number(a.treating) || a.name.localeCompare(b.name));
}

/** A group about a patient is named after them (the hub allows 80 characters). */
export function patientGroupName(title: string): string | undefined {
  const name = title.trim();
  return name ? name.slice(0, 80) : undefined;
}

/**
 * The composer with a patient a Chat button asked for: "#Name " at the start of the box and the mention added, or
 * null when that patient is already tagged. `text` is what the mention put in the box.
 */
export function prefillDraft<M extends PatientMention & { text: string }>(
  draft: string,
  mentions: readonly M[],
  patient: PatientMention,
): { draft: string; mentions: (M | (PatientMention & { text: string }))[] } | null {
  if (mentions.some((m) => m.patientRef === patient.patientRef)) return null;
  const text = `#${patient.title}`;
  return { draft: `${text} ${draft}`, mentions: [...mentions, { ...patient, text }] };
}
